(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const TRENDSPY_TEXTS = {
    fr: {
      cart: 'Panier',
      item: 'article',
      items: 'articles',
      close_cart: 'Fermer le panier',
      cart_empty_title: 'Ton panier est vide',
      cart_empty_body: 'Ajoute tes produits favoris pour retrouver ici un panier premium, rapide et rassurant.',
      view_cart: 'Voir le panier',
      continue_shopping: 'Continuer vos achats',
      free_shipping_away: 'Il manque {amount} pour la livraison offerte.',
      free_shipping_unlocked: 'Livraison offerte débloquée',
      cart_ready_checkout: 'Panier prêt pour le paiement',
      discount: 'Réduction',
      remove: 'Retirer',
      product: 'Produit',
      quantity_for: 'Quantité pour {product}',
      decrease_quantity: 'Diminuer la quantité',
      increase_quantity: 'Augmenter la quantité',
      you_save: 'Vous économisez {amount}',
      cart_reserved_for: 'Panier réservé pendant',
      easy_returns: 'Retours faciles',
      fast_shipping: 'Livraison rapide',
      support_247: 'Support 24/7',
      free_shipping: 'Livraison offerte',
      off_20: '-20%',
      free_gift: 'Cadeau offert',
      enter_discount_code: 'Code promo',
      add_discount: 'AJOUTER',
      discount_note_empty: 'Le code sera appliqué au checkout.',
      discount_note_applied: 'Code appliqué au checkout.',
      savings: 'Économies',
      subtotal: 'Sous-total',
      checkout: 'Paiement',
      open_full_cart: 'Ouvrir le panier complet',
      secure_payment_note: 'Paiement sécurisé • suivi de commande • support disponible'
    },
    en: {
      cart: 'Cart',
      item: 'item',
      items: 'items',
      close_cart: 'Close cart',
      cart_empty_title: 'Your cart is empty',
      cart_empty_body: 'Add your favorite products to find them here in a premium, fast and reassuring cart drawer.',
      view_cart: 'View cart',
      continue_shopping: 'Continue shopping',
      free_shipping_away: 'You are {amount} away from FREE shipping.',
      free_shipping_unlocked: 'FREE shipping unlocked',
      cart_ready_checkout: 'Cart ready for checkout',
      discount: 'Discount',
      remove: 'Remove',
      product: 'Product',
      quantity_for: 'Quantity for {product}',
      decrease_quantity: 'Decrease quantity',
      increase_quantity: 'Increase quantity',
      you_save: 'You save {amount}',
      cart_reserved_for: 'Cart reserved for',
      easy_returns: 'Easy Returns',
      fast_shipping: 'Fast Shipping',
      support_247: '24/7 Support',
      free_shipping: 'Free Shipping',
      off_20: '20% OFF',
      free_gift: 'Free Gift',
      enter_discount_code: 'Enter discount code',
      add_discount: 'ADD',
      discount_note_empty: 'The code will be applied at checkout.',
      discount_note_applied: 'Code applied at checkout.',
      savings: 'Savings',
      subtotal: 'Subtotal',
      checkout: 'Check out',
      open_full_cart: 'Open full cart',
      secure_payment_note: 'Secure payment • order tracking • support available'
    }
  };

  function getThemeLanguage() {
    const drawer = document.querySelector('[data-trendspy-cart-drawer]');
    const raw = (drawer && drawer.dataset.trendspyLang) || document.documentElement.lang || 'fr';
    return String(raw).toLowerCase().startsWith('en') ? 'en' : 'fr';
  }

  function t(key, replacements = {}) {
    let text = (TRENDSPY_TEXTS[getThemeLanguage()] && TRENDSPY_TEXTS[getThemeLanguage()][key])
      || TRENDSPY_TEXTS.fr[key]
      || key;

    Object.keys(replacements).forEach((name) => {
      text = text.replace(new RegExp('\\{' + name + '\\}', 'g'), replacements[name]);
    });

    return text;
  }

  function parseVariantPayload(root) {
    const node = root.querySelector('[data-trendspy-variants]');
    if (!node) {
      return [];
    }

    try {
      const payload = JSON.parse(node.textContent || '[]');
      return Array.isArray(payload) ? payload : [];
    } catch (error) {
      return [];
    }
  }

  function formatMoney(root, cents) {
    const currency = root.dataset.trendspyCurrency || 'EUR';
    const locale = document.documentElement.lang || 'fr-FR';
    const amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getShopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function getShopifyUrl(path) {
    return getShopifyRoot() + String(path || '').replace(/^\/+/, '');
  }

  function getCartDrawer() {
    return document.querySelector('[data-trendspy-cart-drawer]');
  }

  function getStoredValue(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStoredValue(key, value) {
    try {
      if (value === '') {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(key, value);
      }
    } catch (error) {
      // Ignore localStorage failures.
    }
  }

  function getCartDiscountCode() {
    return getStoredValue('trendspy_cart_discount_code') || '';
  }

  function setCartDiscountCode(value) {
    setStoredValue('trendspy_cart_discount_code', String(value || '').trim());
  }

  function getCartReservationDeadline(drawer, cart) {
    if (!drawer || !cart || Number(cart.item_count || 0) < 1) {
      setStoredValue('trendspy_cart_reserved_until', '');
      return 0;
    }

    const durationSeconds = Math.max(60, Number.parseInt(drawer.dataset.trendspyReservationSeconds || '130', 10) || 130);
    const now = Date.now();
    let deadline = Number.parseInt(getStoredValue('trendspy_cart_reserved_until') || '0', 10) || 0;

    if (deadline <= now) {
      deadline = now + durationSeconds * 1000;
      setStoredValue('trendspy_cart_reserved_until', String(deadline));
    }

    return deadline;
  }

  function formatCountdown(totalSeconds) {
    const safeSeconds = Math.max(0, totalSeconds);
    const minutes = Math.floor(safeSeconds / 60);
    const seconds = safeSeconds % 60;
    return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }

  function syncCartReservationTimer(drawer, cart) {
    if (!drawer) {
      return;
    }

    if (drawer._trendspyReservationInterval) {
      window.clearInterval(drawer._trendspyReservationInterval);
      drawer._trendspyReservationInterval = null;
    }

    const node = drawer.querySelector('[data-trendspy-cart-reservation]');
    if (!node) {
      return;
    }

    if (!cart || Number(cart.item_count || 0) < 1) {
      node.textContent = '00:00';
      return;
    }

    const updateTimer = () => {
      let deadline = getCartReservationDeadline(drawer, cart);
      const now = Date.now();

      if (deadline <= now) {
        deadline = now + (Math.max(60, Number.parseInt(drawer.dataset.trendspyReservationSeconds || '130', 10) || 130) * 1000);
        setStoredValue('trendspy_cart_reserved_until', String(deadline));
      }

      const remainingSeconds = Math.ceil((deadline - now) / 1000);
      node.textContent = formatCountdown(remainingSeconds);
    };

    updateTimer();
    drawer._trendspyReservationInterval = window.setInterval(updateTimer, 1000);
  }

  function updateCartCountUi(cart) {
    const itemCount = Number(cart && cart.item_count ? cart.item_count : 0);
    document.querySelectorAll('[data-trendspy-cart-count]').forEach((node) => {
      node.textContent = String(itemCount);
      node.hidden = itemCount < 1;
    });
  }

  function calculateCartSavings(cart) {
    const originalTotal = Number(cart && cart.original_total_price ? cart.original_total_price : 0);
    const finalTotal = Number(cart && cart.total_price ? cart.total_price : 0);
    return Math.max(0, originalTotal - finalTotal);
  }

  function buildDrawerCheckoutUrl(drawer) {
    const discountCode = getCartDiscountCode();
    const checkoutUrl = drawer && drawer.dataset.trendspyCheckoutUrl
      ? drawer.dataset.trendspyCheckoutUrl
      : '/checkout';

    if (!discountCode) {
      return checkoutUrl;
    }

    return getShopifyUrl('discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(checkoutUrl));
  }

  function renderCartDrawer(cart) {
    const drawer = getCartDrawer();
    if (!drawer) {
      return;
    }

    const content = drawer.querySelector('[data-trendspy-cart-drawer-content]');
    if (!content) {
      return;
    }

    const itemCount = Number(cart && cart.item_count ? cart.item_count : 0);
    const discountCode = getCartDiscountCode();
    const drawerTitle = t('cart') + ' • ' + itemCount + ' ' + t(itemCount > 1 ? 'items' : 'item');

    if (itemCount < 1) {
      content.innerHTML = `
        <div class="ts-cart-drawer-head">
          <h2>${drawerTitle}</h2>
          <button type="button" class="ts-cart-drawer-close" data-trendspy-cart-close aria-label="${escapeHtml(t('close_cart'))}">x</button>
        </div>
        <div class="ts-cart-drawer-empty">
          <p class="ts-kicker">Panier vide</p>
          <h3>${escapeHtml(t('cart_empty_title'))}</h3>
          <p>${escapeHtml(t('cart_empty_body'))}</p>
          <a class="ts-button ts-button-block ts-action-link ts-action-link-cart" href="${escapeHtml(drawer.dataset.trendspyCartUrl || '/collections/all')}">${escapeHtml(t('view_cart'))}</a>
          <a class="ts-button ts-button-outline ts-button-block" href="/collections/all">${escapeHtml(t('continue_shopping'))}</a>
        </div>
      `;
      syncCartReservationTimer(drawer, cart);
      updateCartCountUi(cart);
      return;
    }

    const threshold = Math.max(0, Number.parseInt(drawer.dataset.trendspyFreeShippingThreshold || '0', 10) || 0);
    const totalPrice = Number(cart.total_price || 0);
    const remainingToFreeShipping = Math.max(0, threshold - totalPrice);
    const freeShippingProgress = threshold > 0 ? Math.min(100, Math.round((totalPrice / threshold) * 100)) : 100;
    const progressLabel = threshold > 0
      ? (remainingToFreeShipping > 0
          ? t('free_shipping_away', { amount: formatMoney(drawer, remainingToFreeShipping) })
          : t('free_shipping_unlocked'))
      : t('cart_ready_checkout');
    const savings = calculateCartSavings(cart);
    const cartItemsHtml = (Array.isArray(cart.items) ? cart.items : []).map((item, index) => {
      const itemUrl = item.url || (drawer.dataset.trendspyCartUrl || '/cart');
      const compareLinePrice = Number(item.original_line_price || 0);
      const finalLinePrice = Number(item.final_line_price || 0);
      const lineSavings = Math.max(0, compareLinePrice - finalLinePrice);
      const lineDiscounts = Array.isArray(item.line_level_discount_allocations) && item.line_level_discount_allocations.length > 0
        ? `
          <ul class="ts-cart-drawer-item-discounts">
            ${item.line_level_discount_allocations.map((discount) => `
              <li>${escapeHtml(discount.discount_application && discount.discount_application.title ? discount.discount_application.title : t('discount'))} (-${formatMoney(drawer, Number(discount.amount || 0))})</li>
            `).join('')}
          </ul>
        `
        : '';
      const compareMarkup = compareLinePrice > finalLinePrice
        ? `<span class="ts-cart-drawer-item-compare">${formatMoney(drawer, compareLinePrice)}</span>`
        : '';
      const variantMarkup = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="ts-cart-drawer-item-variant">${escapeHtml(item.variant_title)}</p>`
        : '';
      const savingsMarkup = lineSavings > 0
        ? `<p class="ts-cart-drawer-item-saving">${escapeHtml(t('you_save', { amount: formatMoney(drawer, lineSavings) }))}</p>`
        : '';

      return `
        <article class="ts-cart-drawer-item" data-trendspy-drawer-line="${index + 1}">
          <a class="ts-cart-drawer-item-media" href="${escapeHtml(itemUrl)}">
            ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title || item.title || t('product'))}">` : ''}
          </a>
          <div class="ts-cart-drawer-item-body">
            <div class="ts-cart-drawer-item-top">
              <div>
                <h3><a href="${escapeHtml(itemUrl)}">${escapeHtml(item.product_title || item.title || t('product'))}</a></h3>
                ${variantMarkup}
              </div>
              <button type="button" class="ts-cart-drawer-remove" data-trendspy-drawer-remove aria-label="${escapeHtml(t('remove'))}">${escapeHtml(t('remove'))}</button>
            </div>
            <div class="ts-cart-drawer-item-meta">
              <div class="ts-cart-drawer-qty">
                <button type="button" class="ts-qty-button" data-trendspy-drawer-minus aria-label="${escapeHtml(t('decrease_quantity'))}">-</button>
                <input type="number" min="0" value="${Number(item.quantity || 0)}" data-trendspy-drawer-quantity aria-label="${escapeHtml(t('quantity_for', { product: item.product_title || item.title || t('product') }))}">
                <button type="button" class="ts-qty-button" data-trendspy-drawer-plus aria-label="${escapeHtml(t('increase_quantity'))}">+</button>
              </div>
              <div class="ts-cart-drawer-item-prices">
                ${compareMarkup}
                <strong>${formatMoney(drawer, finalLinePrice)}</strong>
                ${savingsMarkup}
              </div>
            </div>
            ${lineDiscounts}
          </div>
        </article>
      `;
    }).join('');

    content.innerHTML = `
      <div class="ts-cart-drawer-head">
        <h2>${drawerTitle}</h2>
        <button type="button" class="ts-cart-drawer-close" data-trendspy-cart-close aria-label="${escapeHtml(t('close_cart'))}">x</button>
      </div>
      <div class="ts-cart-drawer-reserved">
        ${escapeHtml(t('cart_reserved_for'))} <strong data-trendspy-cart-reservation>00:00</strong>
      </div>
      <div class="ts-cart-drawer-perks">
        <span>${escapeHtml(t('easy_returns'))}</span>
        <span>${escapeHtml(t('fast_shipping'))}</span>
        <span>${escapeHtml(t('support_247'))}</span>
      </div>
      <div class="ts-cart-drawer-progress">
        <p>${progressLabel}</p>
        <div class="ts-cart-drawer-progress-bar">
          <span style="width:${freeShippingProgress}%"></span>
        </div>
        <div class="ts-cart-drawer-progress-steps">
          <span>${escapeHtml(t('free_shipping'))}</span>
          <span>${escapeHtml(t('off_20'))}</span>
          <span>${escapeHtml(t('free_gift'))}</span>
        </div>
      </div>
      <div class="ts-cart-drawer-items">${cartItemsHtml}</div>
      <div class="ts-cart-drawer-footer">
        <div class="ts-cart-drawer-discount">
          <input type="text" value="${escapeHtml(discountCode)}" placeholder="${escapeHtml(t('enter_discount_code'))}" data-trendspy-drawer-discount-input>
          <button type="button" data-trendspy-drawer-discount-apply>${escapeHtml(t('add_discount'))}</button>
        </div>
        <p class="ts-cart-drawer-discount-note" data-trendspy-drawer-discount-note>${escapeHtml(discountCode ? t('discount_note_applied') : t('discount_note_empty'))}</p>
        <div class="ts-cart-drawer-summary-row">
          <span>${escapeHtml(t('savings'))}</span>
          <strong>${savings > 0 ? '-' + formatMoney(drawer, savings) : formatMoney(drawer, 0)}</strong>
        </div>
        <div class="ts-cart-drawer-summary-row ts-cart-drawer-summary-row-total">
          <span>${escapeHtml(t('subtotal'))}</span>
          <strong>${formatMoney(drawer, totalPrice)}</strong>
        </div>
        <button type="button" class="ts-button ts-button-block ts-cart-drawer-checkout" data-trendspy-drawer-checkout>${escapeHtml(t('checkout'))}</button>
        <p class="ts-cart-drawer-secure-note">${escapeHtml(t('secure_payment_note'))}</p>
        <a class="ts-cart-drawer-view-cart ts-action-link ts-action-link-cart" href="${escapeHtml(drawer.dataset.trendspyCartUrl || '/cart')}">${escapeHtml(t('open_full_cart'))}</a>
      </div>
    `;

    syncCartReservationTimer(drawer, cart);
    updateCartCountUi(cart);
  }

  async function fetchCartState() {
    const response = await fetch(getShopifyUrl('cart.js'), {
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Unable to load cart');
    }

    return response.json();
  }

  async function addItemToCart(formData) {
    const response = await fetch(getShopifyUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: formData,
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Unable to add item to cart');
    }

    return response.json();
  }

  async function changeCartLine(line, quantity) {
    const response = await fetch(getShopifyUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
      }),
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Unable to update cart');
    }

    return response.json();
  }

  async function refreshCartDrawer() {
    const cart = await fetchCartState();
    renderCartDrawer(cart);
    return cart;
  }

  function openCartDrawer() {
    const drawer = getCartDrawer();
    if (!drawer) {
      return;
    }

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ts-cart-drawer-open');
  }

  function closeCartDrawer() {
    const drawer = getCartDrawer();
    if (!drawer) {
      return;
    }

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ts-cart-drawer-open');
  }

  function updateGalleryStage(root, src, alt) {
    const stage = root.querySelector('[data-trendspy-gallery-stage]');
    if (!stage || !src) {
      return;
    }

    stage.setAttribute('src', src);
    if (alt) {
      stage.setAttribute('alt', alt);
    }
  }

  function normalizeGallerySrc(src) {
    const rawValue = String(src || '').trim();
    if (!rawValue) {
      return '';
    }

    try {
      const normalizedUrl = new URL(rawValue, window.location.origin);
      normalizedUrl.search = '';
      return normalizedUrl.toString();
    } catch (error) {
      return rawValue.split('?')[0];
    }
  }

  function getGalleryThumbs(root) {
    return Array.from(root.querySelectorAll('[data-trendspy-thumb]'));
  }

  function updateGalleryControls(root, activeIndex, total) {
    const counter = root.querySelector('[data-trendspy-gallery-count]');
    if (counter) {
      counter.textContent = total > 1 ? String(activeIndex + 1) + ' / ' + String(total) : '';
      counter.hidden = total <= 1;
    }

    root.querySelectorAll('[data-trendspy-gallery-prev], [data-trendspy-gallery-next]').forEach((button) => {
      button.disabled = total <= 1;
      button.hidden = total <= 1;
    });
  }

  function setActiveGalleryIndex(root, index, options = {}) {
    const thumbs = getGalleryThumbs(root);
    if (!thumbs.length) {
      updateGalleryControls(root, 0, 0);
      return;
    }

    const normalizedIndex = ((index % thumbs.length) + thumbs.length) % thumbs.length;
    const activeThumb = thumbs[normalizedIndex];

    thumbs.forEach((thumb, thumbIndex) => {
      thumb.classList.toggle('is-active', thumbIndex === normalizedIndex);
    });

    updateGalleryStage(
      root,
      activeThumb.getAttribute('data-trendspy-thumb'),
      activeThumb.getAttribute('data-trendspy-thumb-alt')
    );

    root.dataset.trendspyGalleryIndex = String(normalizedIndex);
    updateGalleryControls(root, normalizedIndex, thumbs.length);

    if (options.scroll !== false) {
      activeThumb.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }

  function findGalleryIndexBySrc(root, src) {
    const targetSrc = normalizeGallerySrc(src);
    if (!targetSrc) {
      return -1;
    }

    return getGalleryThumbs(root).findIndex((thumb) => {
      return normalizeGallerySrc(thumb.getAttribute('data-trendspy-thumb')) === targetSrc;
    });
  }

  function updateBundleCards(root, variant) {
    if (!variant) {
      return;
    }

    const productTitle = root.dataset.trendspyProductTitle || '';
    const bundleLabel = variant.title && variant.title !== 'Default Title'
      ? productTitle + ' • ' + variant.title
      : productTitle;
    const bundleImageSrc = variant.featured_image && variant.featured_image.src
      ? variant.featured_image.src
      : '';
    const bundleImageAlt = variant.featured_image && variant.featured_image.alt
      ? variant.featured_image.alt
      : (bundleLabel || productTitle);

    root.querySelectorAll('[data-trendspy-bundle]').forEach((card) => {
      const quantity = normalizeQuantityValue(card.dataset.quantity || 1);
      const price = card.querySelector('[data-trendspy-bundle-price]');
      const compare = card.querySelector('[data-trendspy-bundle-compare]');
      const product = card.querySelector('[data-trendspy-bundle-product]');
      const image = card.querySelector('[data-trendspy-bundle-image]');

      if (price) {
        price.textContent = formatMoney(root, Number(variant.price || 0) * quantity);
      }

      if (compare) {
        const compareCents = Number(variant.compare_at_price || 0) * quantity;
        if (compareCents > 0) {
          compare.textContent = formatMoney(root, compareCents);
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }
      }

      if (product && bundleLabel) {
        product.textContent = bundleLabel;
      }

      if (image && bundleImageSrc) {
        image.setAttribute('src', bundleImageSrc);
        image.setAttribute('alt', bundleImageAlt);
      }
    });
  }

  function updateVariantState(root, variant) {
    if (!variant) {
      root.querySelectorAll('[data-trendspy-submit]').forEach((button) => {
        const unavailableLabel = button.dataset.labelUnavailable || 'Indisponible';
        button.disabled = true;
        button.textContent = unavailableLabel;
      });
      return;
    }

    root.querySelectorAll('[data-trendspy-variant-input], [data-trendspy-sticky-variant-input]').forEach((input) => {
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const price = root.querySelector('[data-trendspy-price]');
    const stickyPrice = root.querySelector('[data-trendspy-sticky-price]');
    const compare = root.querySelector('[data-trendspy-compare]');
    const formattedPrice = formatMoney(root, variant.price);

    if (price) {
      price.textContent = formattedPrice;
    }
    if (stickyPrice) {
      stickyPrice.textContent = formattedPrice;
    }

    if (compare) {
      if (variant.compare_at_price) {
        compare.textContent = formatMoney(root, variant.compare_at_price);
        compare.hidden = false;
      } else {
        compare.textContent = '';
        compare.hidden = true;
      }
    }

    updateBundleCards(root, variant);

    if (variant.featured_image && variant.featured_image.src) {
      const galleryIndex = findGalleryIndexBySrc(root, variant.featured_image.src);
      if (galleryIndex >= 0) {
        setActiveGalleryIndex(root, galleryIndex);
      } else {
        updateGalleryStage(root, variant.featured_image.src, variant.featured_image.alt || variant.name || '');
      }
    }

    root.querySelectorAll('[data-trendspy-submit]').forEach((button) => {
      const availableLabel = button.dataset.labelAvailable || 'Ajouter au panier';
      const unavailableLabel = button.dataset.labelUnavailable || 'Indisponible';
      button.disabled = !variant.available;
      button.textContent = variant.available ? availableLabel : unavailableLabel;
    });
  }

  function normalizeQuantityValue(quantity) {
    const parsedQuantity = Number.parseInt(String(quantity || 1), 10);
    return Number.isFinite(parsedQuantity) ? Math.max(1, parsedQuantity) : 1;
  }

  function normalizeCartQuantityValue(quantity) {
    const parsedQuantity = Number.parseInt(String(quantity || 0), 10);
    return Number.isFinite(parsedQuantity) ? Math.max(0, parsedQuantity) : 0;
  }

  function submitForm(form, submitter = null) {
    if (!form) {
      return;
    }

    if (typeof form.requestSubmit === 'function') {
      if (submitter) {
        form.requestSubmit(submitter);
      } else {
        form.requestSubmit();
      }
      return;
    }

    let fallbackSubmitterInput = null;
    if (submitter && submitter.name) {
      fallbackSubmitterInput = document.createElement('input');
      fallbackSubmitterInput.type = 'hidden';
      fallbackSubmitterInput.name = submitter.name;
      fallbackSubmitterInput.value = submitter.value || '';
      form.appendChild(fallbackSubmitterInput);
    }

    form.submit();

    if (fallbackSubmitterInput) {
      fallbackSubmitterInput.remove();
    }
  }

  function syncQuantity(root, quantity) {
    const safeQuantity = normalizeQuantityValue(quantity);
    root.querySelectorAll('[data-trendspy-quantity-input], [data-trendspy-sticky-quantity-input]').forEach((input) => {
      input.value = String(safeQuantity);
    });
    root.querySelectorAll('[data-trendspy-quantity-display]').forEach((input) => {
      input.value = String(safeQuantity);
    });
  }

  function findVariantByOptions(variants, values) {
    return variants.find((variant) => {
      return values.every((value, index) => {
        return String(variant['option' + (index + 1)] || '').trim() === String(value || '').trim();
      });
    });
  }

  function initReveal(root = document) {
    const items = Array.from(root.querySelectorAll('[data-ts-animate]')).filter((item) => !item.dataset.tsObserved);
    if (items.length === 0) {
      return;
    }

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -60px 0px',
    });

    items.forEach((item) => {
      if (item.dataset.tsDelay) {
        item.style.setProperty('--ts-delay', item.dataset.tsDelay + 'ms');
      }
      item.dataset.tsObserved = 'true';
      observer.observe(item);
    });
  }

  function initSticky(root) {
    const sticky = root.querySelector('[data-trendspy-sticky]');
    const boundary = root.querySelector('[data-trendspy-sticky-boundary]');

    if (!sticky || !boundary || !('IntersectionObserver' in window)) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, {
      threshold: 0.15,
    });

    observer.observe(boundary);
  }

  function initCartDrawer() {
    const drawer = getCartDrawer();
    if (!drawer || drawer.dataset.trendspyInitialized === 'true') {
      return;
    }
    drawer.dataset.trendspyInitialized = 'true';

    document.addEventListener('click', async (event) => {
      const toggle = event.target.closest('[data-trendspy-cart-toggle]');
      if (toggle) {
        event.preventDefault();
        openCartDrawer();
        try {
          await refreshCartDrawer();
        } catch (error) {
          window.location.href = toggle.getAttribute('href') || '/cart';
        }
        return;
      }

      if (event.target.closest('[data-trendspy-cart-close]')) {
        event.preventDefault();
        closeCartDrawer();
        return;
      }

      const discountApply = event.target.closest('[data-trendspy-drawer-discount-apply]');
      if (discountApply) {
        const input = drawer.querySelector('[data-trendspy-drawer-discount-input]');
        const note = drawer.querySelector('[data-trendspy-drawer-discount-note]');
        const code = input ? input.value.trim() : '';
        setCartDiscountCode(code);
        if (note) {
          note.textContent = code ? t('discount_note_applied') : t('discount_note_empty');
        }
        return;
      }

      const checkoutTrigger = event.target.closest('[data-trendspy-drawer-checkout]');
      if (checkoutTrigger) {
        event.preventDefault();
        window.location.href = buildDrawerCheckoutUrl(drawer);
        return;
      }

      const minusButton = event.target.closest('[data-trendspy-drawer-minus]');
      const plusButton = event.target.closest('[data-trendspy-drawer-plus]');
      const removeButton = event.target.closest('[data-trendspy-drawer-remove]');
      const lineItem = event.target.closest('[data-trendspy-drawer-line]');

      if (!lineItem) {
        return;
      }

      const line = Number.parseInt(lineItem.getAttribute('data-trendspy-drawer-line') || '0', 10);
      if (!Number.isFinite(line) || line < 1) {
        return;
      }

      const quantityInput = lineItem.querySelector('[data-trendspy-drawer-quantity]');
      if (!quantityInput) {
        return;
      }

      if (removeButton) {
        event.preventDefault();
        try {
          renderCartDrawer(await changeCartLine(line, 0));
        } catch (error) {
          window.location.href = drawer.dataset.trendspyCartUrl || '/cart';
        }
        return;
      }

      if (minusButton || plusButton) {
        event.preventDefault();
        const currentQuantity = normalizeCartQuantityValue(quantityInput.value);
        const nextQuantity = minusButton ? Math.max(0, currentQuantity - 1) : currentQuantity + 1;

        try {
          renderCartDrawer(await changeCartLine(line, nextQuantity));
        } catch (error) {
          window.location.href = drawer.dataset.trendspyCartUrl || '/cart';
        }
      }
    });

    drawer.addEventListener('change', async (event) => {
      const quantityInput = event.target.closest('[data-trendspy-drawer-quantity]');
      if (!quantityInput) {
        return;
      }

      const lineItem = quantityInput.closest('[data-trendspy-drawer-line]');
      const line = lineItem ? Number.parseInt(lineItem.getAttribute('data-trendspy-drawer-line') || '0', 10) : 0;
      if (!Number.isFinite(line) || line < 1) {
        return;
      }

      const nextQuantity = normalizeCartQuantityValue(quantityInput.value);
      try {
        renderCartDrawer(await changeCartLine(line, nextQuantity));
      } catch (error) {
        window.location.href = drawer.dataset.trendspyCartUrl || '/cart';
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeCartDrawer();
      }
    });

    refreshCartDrawer().catch(() => {});
  }

  function initCart(root) {
    if (root.dataset.trendspyCartInitialized === 'true') {
      return;
    }
    root.dataset.trendspyCartInitialized = 'true';

    const cartForm = root.querySelector('[data-trendspy-cart-form]');
    if (!cartForm) {
      return;
    }
    const autoSubmitter = cartForm.querySelector('[data-trendspy-cart-auto-submit]');

    root.addEventListener('click', (event) => {
      const minusButton = event.target.closest('[data-trendspy-cart-minus]');
      const plusButton = event.target.closest('[data-trendspy-cart-plus]');
      const trigger = minusButton || plusButton;

      if (!trigger) {
        return;
      }

      const input = trigger.parentElement ? trigger.parentElement.querySelector('[data-trendspy-cart-quantity]') : null;
      if (!input) {
        return;
      }

      const currentQuantity = normalizeCartQuantityValue(input.value);
      const nextQuantity = minusButton
        ? Math.max(0, currentQuantity - 1)
        : currentQuantity + 1;

      input.value = String(nextQuantity);
      submitForm(cartForm, autoSubmitter);
    });

    root.addEventListener('change', (event) => {
      const quantityInput = event.target.closest('[data-trendspy-cart-quantity]');
      if (!quantityInput) {
        return;
      }

      quantityInput.value = String(normalizeCartQuantityValue(quantityInput.value));
    });

    cartForm.addEventListener('submit', () => {
      cartForm.querySelectorAll('[data-trendspy-cart-quantity]').forEach((input) => {
        input.value = String(normalizeCartQuantityValue(input.value));
      });
    });
  }

  function initProduct(root) {
    if (root.dataset.trendspyInitialized === 'true') {
      return;
    }
    root.dataset.trendspyInitialized = 'true';

    const variants = parseVariantPayload(root);
    const optionInputs = Array.from(root.querySelectorAll('[data-trendspy-option]'));
    setActiveGalleryIndex(root, Number.parseInt(root.dataset.trendspyGalleryIndex || '0', 10) || 0, { scroll: false });

    root.addEventListener('click', (event) => {
      const previousButton = event.target.closest('[data-trendspy-gallery-prev]');
      if (previousButton) {
        setActiveGalleryIndex(root, Number(root.dataset.trendspyGalleryIndex || 0) - 1);
        return;
      }

      const nextButton = event.target.closest('[data-trendspy-gallery-next]');
      if (nextButton) {
        setActiveGalleryIndex(root, Number(root.dataset.trendspyGalleryIndex || 0) + 1);
        return;
      }

      const thumb = event.target.closest('[data-trendspy-thumb]');
      if (thumb) {
        const thumbIndex = Number.parseInt(thumb.getAttribute('data-trendspy-thumb-index') || '-1', 10);
        setActiveGalleryIndex(
          root,
          Number.isFinite(thumbIndex) && thumbIndex >= 0 ? thumbIndex : getGalleryThumbs(root).indexOf(thumb)
        );
        return;
      }

      const bundle = event.target.closest('[data-trendspy-bundle]');
      if (bundle) {
        const wrapper = bundle.closest('[data-trendspy-bundles]');
        if (wrapper) {
          wrapper.querySelectorAll('[data-trendspy-bundle]').forEach((node) => {
            node.classList.toggle('is-active', node === bundle);
          });
        }
        syncQuantity(root, bundle.dataset.quantity || 1);
        return;
      }

      if (event.target.closest('[data-trendspy-qty-minus]')) {
        const input = root.querySelector('[data-trendspy-quantity-display]');
        syncQuantity(root, Math.max(1, Number(input ? input.value : 1) - 1));
        return;
      }

      if (event.target.closest('[data-trendspy-qty-plus]')) {
        const input = root.querySelector('[data-trendspy-quantity-display]');
        syncQuantity(root, Math.max(1, Number(input ? input.value : 1) + 1));
        return;
      }

    });

    root.addEventListener('input', (event) => {
      const quantityDisplay = event.target.closest('[data-trendspy-quantity-display]');
      if (quantityDisplay) {
        syncQuantity(root, quantityDisplay.value);
      }
    });

    root.addEventListener('submit', async (event) => {
      const form = event.target.closest('.ts-product-form, .ts-sticky-form');
      if (!form) {
        return;
      }

      const submitter = event.submitter;
      if (form.classList.contains('ts-product-form') && (!submitter || !submitter.matches('[data-trendspy-submit]'))) {
        return;
      }

      event.preventDefault();
      if (submitter) {
        submitter.disabled = true;
      }

      try {
        await addItemToCart(new FormData(form));
        openCartDrawer();
        await refreshCartDrawer();
      } catch (error) {
        form.submit();
      } finally {
        if (submitter) {
          submitter.disabled = false;
        }
      }
    });

    if (optionInputs.length > 0 && variants.length > 0) {
      const handleOptionChange = () => {
        const values = optionInputs.map((input) => input.value);
        const variant = findVariantByOptions(variants, values);
        updateVariantState(root, variant);
      };

      optionInputs.forEach((input) => input.addEventListener('change', handleOptionChange));
      handleOptionChange();
    } else if (variants.length > 0) {
      const variantInput = root.querySelector('[data-trendspy-variant-input], [data-trendspy-sticky-variant-input]');
      const initialVariantId = variantInput ? String(variantInput.value || '') : '';
      const initialVariant = variants.find((variant) => String(variant.id) === initialVariantId) || variants.find((variant) => variant.available) || variants[0];
      updateVariantState(root, initialVariant);
    }

    syncQuantity(root, 1);
    initSticky(root);
  }

  function initMobileNav(root) {
    const navRoots = root.matches && root.matches('[data-trendspy-mobile-nav-root]')
      ? [root]
      : Array.from(root.querySelectorAll('[data-trendspy-mobile-nav-root]'));

    navRoots.forEach((navRoot) => {
      if (navRoot.dataset.trendspyMobileNavInitialized === 'true') {
        return;
      }
      navRoot.dataset.trendspyMobileNavInitialized = 'true';

      const toggle = navRoot.querySelector('[data-trendspy-mobile-nav-toggle]');
      const shell = navRoot.querySelector('[data-trendspy-mobile-nav]');
      const panel = shell ? shell.querySelector('.ts-mobile-nav-panel') : null;

      if (!toggle || !shell || !panel) {
        return;
      }

      const closeNav = (restoreFocus = false) => {
        shell.classList.remove('is-open');
        shell.setAttribute('aria-hidden', 'true');
        navRoot.classList.remove('is-mobile-nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('ts-mobile-nav-open');

        if (restoreFocus) {
          toggle.focus();
        }
      };

      const openNav = () => {
        shell.classList.add('is-open');
        shell.setAttribute('aria-hidden', 'false');
        navRoot.classList.add('is-mobile-nav-open');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('ts-mobile-nav-open');
        window.requestAnimationFrame(() => {
          panel.focus();
        });
      };

      navRoot.addEventListener('click', (event) => {
        if (event.target.closest('[data-trendspy-mobile-nav-toggle]')) {
          event.preventDefault();
          if (shell.classList.contains('is-open')) {
            closeNav(true);
          } else {
            openNav();
          }
          return;
        }

        if (event.target.closest('[data-trendspy-mobile-nav-close]')) {
          event.preventDefault();
          closeNav(true);
          return;
        }

        if (event.target.closest('[data-trendspy-mobile-nav-link]')) {
          closeNav(false);
        }
      });

      shell.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeNav(true);
        }
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth > 900 && shell.classList.contains('is-open')) {
          closeNav(false);
        }
      });
    });
  }

  function initProductInfoTabs(root) {
    const tabRoots = root.matches && root.matches('[data-trendspy-product-tabs]')
      ? [root]
      : Array.from(root.querySelectorAll('[data-trendspy-product-tabs]'));

    tabRoots.forEach((tabRoot) => {
      if (tabRoot.dataset.trendspyProductTabsInitialized === 'true') {
        return;
      }
      tabRoot.dataset.trendspyProductTabsInitialized = 'true';

      tabRoot.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-trendspy-product-tab]');
        if (!tab || !tabRoot.contains(tab)) {
          return;
        }

        const target = tab.dataset.trendspyProductTab;
        tabRoot.querySelectorAll('[data-trendspy-product-tab]').forEach((button) => {
          const isActive = button === tab;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        tabRoot.querySelectorAll('[data-trendspy-product-panel]').forEach((panel) => {
          const isActive = panel.dataset.trendspyProductPanel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });
  }

  function initAll(root = document) {
    initReveal(root);
    initMobileNav(root);
    initProductInfoTabs(root);
    initCartDrawer();
    root.querySelectorAll('[data-trendspy-cart-root]').forEach(initCart);
    root.querySelectorAll('[data-trendspy-product-root]').forEach(initProduct);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();